function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef } from 'react';
import { merge } from 'lodash-es';
import { useIsInBottomSheet } from "../BottomSheet";
import { useDevice } from "../Device";
import { useOverlayContext } from "../OverlayContext";
import { useIsInModal } from "../OverlayContext/ModalContainer";
import { BaseTextField } from "../TextField/BaseTextField/BaseTextField";
import { MobileSelect, SelectOptionsBottomSheet } from "./MobileSelect";
import { jsx as _jsx } from "react/jsx-runtime";
export const Select = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isMobileDevice
  } = useDevice();
  const isInBottomSheet = useIsInBottomSheet();
  const isInModal = useIsInModal();
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  if (isInBottomSheet) {
    return /*#__PURE__*/_jsx(BaseTextField, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      select: true,
      SelectProps: merge(props.SelectProps, {
        open: false,
        onOpen: () => {
          pushBottomSheetPage({
            content: /*#__PURE__*/_jsx(SelectOptionsBottomSheet, _objectSpread({
              saveOnSelect: true
            }, props))
          });
        }
      })
    }));
  } else if (isMobileDevice && !isInModal) {
    return /*#__PURE__*/_jsx(MobileSelect, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  } else {
    return /*#__PURE__*/_jsx(BaseTextField, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      select: true
    }));
  }
});